import React, {Fragment, useState} from 'react';

import Table2 from './Table';
import ImportFromFile from './FileReader'
import ImageUpload from './images';
import {Form, Button, Col, Alert, Accordion, Card} from 'react-bootstrap';


const Inputs = (props) => {
  const [label, setLabel] = useState("");
  const [value, setValue] = useState("");
  const [color, setColor] = useState("#00acff");
  const [image, setImage] = useState("");
  const [click1, setClick1] = useState(false);
  const [click2, setClick2] = useState(false);
  const [click3, setClick3] = useState(false);
  console.log("here he here he" + props.data.length);

  const settingImage = (img) => {
    setImage(img);
    console.log('imaged');
  }

  const itBegins = () => {
    setClick1(!click1);
    props.setStartMode(false);
  }

  const itBegins2 = () => {
    setClick2(!click2);
    props.setStartMode(false);
  }

  const itBegins3 = () => {
    setClick3(!click3);
    props.setStartMode(false);
  }

  return (
    <Fragment>
        <Accordion>
        <Card>
            <Card.Header>
            <Accordion.Toggle as={Button} variant="light" eventKey="0" onClick={() => {itBegins()}}>
                Chart Type Options
                <i aria-hidden="true" className="dropdown icon"></i>
            </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="0">
            <Card.Body>
            {props.chartType == "line" ?
            <Form style={{width: "90%", margin: "0 auto"}}>
            <Form.Row style={{marginTop: "8px"}}>
                <Form.Group as={Col} sm="12" md="4" lg="5" controlId="formBasicEmail">
                    <Form.Label>Chart Type</Form.Label>
                    <Form.Control as="select" custom id="chartType" onChange={e => props.settingChartType(e.target.value)}>
                        <option value="line">Line</option>
                        <option value="bar">Bar</option>
                        <option value="pie">Pie</option>
                        <option value="doughnut">Doughnut</option>
                    </Form.Control>
                </Form.Group>
                <Form.Group controlId="formBasicPassword" as={Col} sm="12" md="4" lg="5">
                    <Form.Label>Title</Form.Label>
                    <Form.Control type="text" placeholder="Title" id="title" value={props.title} onChange={e => props.settingTitle(e.target.value)}/>
                </Form.Group>
                <Form.Group controlId="formBasicPassword" as={Col} sm="12" md="4" lg="2">
                    <Form.Label> Line Color:</Form.Label>
                    <Form.Control type="color" id="vehicle1" name="vehicle1" value={props.lineColor} onChange={(e) => {props.settingLineColor(e.target.value)}}/>
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col} sm="3" md="3" lg="3" controlId="formBasicEmail" onChange={() => {props.displayTitleToggle()}}>
                    <Form.Check type="checkbox" checked={props.displayTitle} label="Display Title" />
                </Form.Group>
                {/* <Form.Group as={Col} sm="2" md="2" lg="2" controlId="formBasicEmail" onChange={() => {props.displayLegendToggle()}}>
                    <Form.Check type="checkbox" checked={props.displayLegend}  label="Display Legend" />
                </Form.Group> */}
                <Form.Group as={Col} sm="3" md="3" lg="3" controlId="formBasicEmail" onChange={() => {props.settingBezierCurve()}}>
                    <Form.Check type="checkbox" checked={props.bezierCurve} label="Bezier Curve" />
                </Form.Group>
                <Form.Group as={Col} sm="3" md="3" lg="3" controlId="formBasicEmail" onChange={() => {props.settingZero()}}>
                    <Form.Check type="checkbox" checked={props.zero} label="Begin at Zero" />
                </Form.Group>
                <Form.Group as={Col} sm="3" md="3" lg="3" controlId="formBasicEmail">
                    <Form.Check type="checkbox" checked={props.fill} label="Fill" onChange={() => {props.settingFill()}}/>
                </Form.Group>
                {/* <Form.Group as={Col} sm="2" md="2" lg="2" controlId="formBasicEmail" onChange={() => {props.settingUseImage()}}>
                    <Form.Check type="checkbox" checked={props.useImage} label="Use Images" />
                </Form.Group> */}
            </Form.Row>
            { props.fill ? <Form.Row style={{borderTop: "1px solid #ced4da"}}>
                    <Form.Group controlId="formBasicPassword" as={Col} sm="12" md="6" lg="6"  style={{marginTop: "8px"}}>
                        <Form.Label>Title</Form.Label>
                        <Form.Control type="color" id="vehicle1" name="vehicle1" value={props.fillColor} onChange={(e) => {props.settingFillColor(e.target.value)}}/>
                    </Form.Group>
                    <Form.Group controlId="formBasicPassword" as={Col} sm="12" md="6" lg="6" style={{marginTop: "8px"}}>
                    <Form.Label>Color Pattern</Form.Label>
                    <Form.Control as="select" custom id="chartType" onChange={e => props.settingFillPattern(e.target.value)}>
                        <option value="none">None</option>
                        <option value="plus">Plus</option>
                        <option value="cross">Cross</option>
                        <option value="dash">Dash</option>
                        <option value="cross-dash">Cross-Dash</option>
                        <option value="dot">Dot</option>
                        <option value="dot-dash">Dot-Dash</option>
                        <option value="disc">Disc</option>
                        <option value="ring">Ring</option>
                        <option value="line">Line</option>
                        <option value="line-vertical">Line-Vertical</option>
                        <option value="weave">Weave</option>
                        <option value="zigzag">Zigzag</option>
                        <option value="zigzag-vertical">Zigzag-Vertical</option>
                        <option value="diagonal">Diagonal</option>
                        <option value="diagonal-right-left">Diagonal-Right-Left</option>
                        <option value="square">Square</option>
                        <option value="box">Box</option>
                        <option value="triangle">Triangle</option>
                        <option value="triangle-inverted">Triangle-Inverted</option>
                        <option value="diamond">Diamond</option>
                        <option value="diamond-box">Diamond-Box</option>
                       
                    </Form.Control>
                </Form.Group>
            </Form.Row>:""}
            </Form>
             : 
             <Form style={{width: "90%", margin: "0 auto"}}>
            <Form.Row style={{marginTop: "8px"}}>
                <Form.Group as={Col} sm="12" md="4" lg="4" controlId="formBasicEmail">
                    <Form.Label>Chart Type</Form.Label>
                    <Form.Control as="select" custom id="chartType" onChange={e => props.settingChartType(e.target.value)}>
                        <option value="line">Line</option>
                        <option value="bar">Bar</option>
                        <option value="pie">Pie</option>
                        <option value="doughnut">Doughnut</option>
                    </Form.Control>
                </Form.Group>
                <Form.Group controlId="formBasicPassword" as={Col} sm="12" md="4" lg="4">
                    <Form.Label>Title</Form.Label>
                    <Form.Control type="text" placeholder="Title" id="title" value={props.title} onChange={e => props.settingTitle(e.target.value)}/>
                </Form.Group>
                <Form.Group controlId="formBasicPassword" as={Col} sm="12" md="4" lg="4">
                    <Form.Label>Label Type</Form.Label>
                    <Form.Control as="select" custom id="chartType" onChange={e => props.settingLabelType(e.target.value)}>
                        <option value="label">Text</option>
                        <option value="value">Value</option>
                        {props.chartType == 'pie' || props.chartType == 'doughnut' ? <option value="percentage">Percentage</option> : ""}
                        <option value="image">Image</option>
                        <option value="image">None</option>
                    </Form.Control>
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col} sm="6" md="6" lg="6" controlId="formBasicEmail" onChange={() => {props.displayTitleToggle()}}>
                    <Form.Check type="checkbox" checked={props.displayTitle} label="Display Title" />
                </Form.Group>
                {/* <Form.Group as={Col} sm="3" md="3" lg="3" controlId="formBasicEmail" onChange={() => {props.displayLegendToggle()}}>
                    <Form.Check type="checkbox" checked={props.displayLegend}  label="Display Legend" />
                </Form.Group> */}
                <Form.Group as={Col} sm="6" md="6" lg="6" controlId="formBasicEmail" onChange={() => {props.settingZero()}}>
                    <Form.Check type="checkbox" checked={props.zero} label="Begin at Zero" />
                </Form.Group>
                {/* <Form.Group as={Col} sm="3" md="3" lg="3" controlId="formBasicEmail" onChange={() => {props.settingUseImage()}}>
                    <Form.Check type="checkbox" checked={props.useImage} label="Use Images" />
                </Form.Group> */}
            </Form.Row>
            </Form>}
            </Card.Body>
            </Accordion.Collapse>
        </Card>
        <Card>
            <Card.Header>
            <Accordion.Toggle as={Button} variant="light" eventKey="2" onClick={() => {itBegins()}}>
                Data Table
                <i aria-hidden="true" className="dropdown icon"></i>
            </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="2">
            <Card.Body>
                <Table2 data={props.data} deleteData={props.deleteData} useImage={props.useImage}/>
            </Card.Body>
            </Accordion.Collapse>
        </Card>
        <Card>
            <Card.Header>
            <Accordion.Toggle as={Button} variant="light" eventKey="1" onClick={() => {itBegins()}}>
                Add Data
                <i aria-hidden="true" className="dropdown icon"></i>
            </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="1">
            <Card.Body>
            <Form style={{width: "90%", margin: "0 auto"}}>
            <Form.Row>
            <Form.Group as={Col} sm="12" md="12" lg="12" controlId="formBasicEmail" onChange={() => {props.settingAnimation()}}>
                <Alert variant="warning" style={{marginTop: "8px"}}>The Sheet being uploaded must have 3 columns labeled "labels, values, colors" in order to be properly parsed</Alert>
                <ImportFromFile csvData={props.csvData}/>
            </Form.Group>
            </Form.Row>
        </Form>
        <Form style={{width: "90%", margin: "0 auto"}}>
            <Form.Row>
            <Form.Group controlId="formBasicPassword" as={Col} sm="12" md="3" lg="3">
                    <Form.Label>Label</Form.Label>
                    <Form.Control type="text" id="label" name="label" value={label} onChange={e => setLabel(e.target.value)}/>
            </Form.Group>
            <Form.Group controlId="formBasicPassword" as={Col} sm="12" md="3" lg="3">
                    <Form.Label>Value</Form.Label>
                    <Form.Control type="text" id="value" name="value" value={value} onChange={e => setValue(e.target.value)}/>
            </Form.Group>
            <Form.Group controlId="formBasicPassword" as={Col} sm="12" md="3" lg="3">
                    <Form.Label>Color</Form.Label>
                    <Form.Control type="color" id="color" name="color" value={color} onChange={e => setColor(e.target.value)}/>
            </Form.Group>
            {props.chartType !== "line" ? <Form.Group controlId="formBasicPassword" as={Col} sm="12" md="3" lg="3">
                    <Form.Label>Color Pattern</Form.Label>
                    <Form.Control as="select" custom id="chartType" onChange={e => props.settingPattern(e.target.value)}>
                        <option value="none">None</option>
                        <option value="plus">Plus</option>
                        <option value="cross">Cross</option>
                        <option value="dash">Dash</option>
                        <option value="cross-dash">Cross-Dash</option>
                        <option value="dot">Dot</option>
                        <option value="dot-dash">Dot-Dash</option>
                        <option value="disc">Disc</option>
                        <option value="ring">Ring</option>
                        <option value="line">Line</option>
                        <option value="line-vertical">Line-Vertical</option>
                        <option value="weave">Weave</option>
                        <option value="zigzag">Zigzag</option>
                        <option value="zigzag-vertical">Zigzag-Vertical</option>
                        <option value="diagonal">Diagonal</option>
                        <option value="diagonal-right-left">Diagonal-Right-Left</option>
                        <option value="square">Square</option>
                        <option value="box">Box</option>
                        <option value="triangle">Triangle</option>
                        <option value="triangle-inverted">Triangle-Inverted</option>
                        <option value="diamond">Diamond</option>
                        <option value="diamond-box">Diamond-Box</option>
                       
                    </Form.Control>
                </Form.Group>: "" }
            {/* <Form.Group controlId="formBasicPassword" as={Col} sm="12" md="3" lg="3">
                    <Form.Label>Image</Form.Label>
                    <ImageUpload display={props.data.length == 0 ? 'block' : 'none' } settingImage={settingImage}/>
                    <ImageUpload display={props.data.length == 1 ? 'block' : 'none' } settingImage={settingImage}/>
                    <ImageUpload display={props.data.length == 2 ? 'block' : 'none' } settingImage={settingImage}/>
                    <ImageUpload display={props.data.length == 3 ? 'block' : 'none' } settingImage={settingImage}/>
                    <ImageUpload display={props.data.length == 4 ? 'block' : 'none' } settingImage={settingImage}/>
                    <ImageUpload display={props.data.length == 5 ? 'block' : 'none' } settingImage={settingImage}/>
                    <ImageUpload display={props.data.length == 6 ? 'block' : 'none' } settingImage={settingImage}/>
                    <ImageUpload display={props.data.length == 7 ? 'block' : 'none' } settingImage={settingImage}/>
                    <ImageUpload display={props.data.length == 8 ? 'block' : 'none' } settingImage={settingImage}/>
                    <ImageUpload display={props.data.length == 9 ? 'block' : 'none' } settingImage={settingImage}/>
                    <ImageUpload display={props.data.length == 10 ? 'block' : 'none' } settingImage={settingImage}/>
                    <ImageUpload display={props.data.length == 11 ? 'block' : 'none' } settingImage={settingImage}/>
                    <ImageUpload display={props.data.length == 12 ? 'block' : 'none' } settingImage={settingImage}/>
                    <ImageUpload display={props.data.length == 13 ? 'block' : 'none' } settingImage={settingImage}/>
                    <ImageUpload display={props.data.length == 14 ? 'block' : 'none' } settingImage={settingImage}/>
                    <ImageUpload display={props.data.length == 15 ? 'block' : 'none' } settingImage={settingImage}/>
                    <ImageUpload display={props.data.length == 16 ? 'block' : 'none' } settingImage={settingImage}/>
                    <ImageUpload display={props.data.length == 17 ? 'block' : 'none' } settingImage={settingImage}/>
                    <ImageUpload display={props.data.length == 18 ? 'block' : 'none' } settingImage={settingImage}/>
                    <ImageUpload display={props.data.length == 19 ? 'block' : 'none' } settingImage={settingImage}/>
            </Form.Group> */}
            </Form.Row>
            {props.labelType == "image" ? <Form>
                <Form.Row >
                <Form.Group as={Col} sm="12" md="12" lg="12">
                <ImageUpload display={props.data.length == 0 ? 'block' : 'none' } num={0} settingImage={settingImage} width={props.width} height={props.height} settingWidth={props.settingWidth} settingHeight={props.settingHeight}/>
                        <ImageUpload display={props.data.length == 1 ? 'block' : 'none' } num={1} settingImage={settingImage} width={props.width} height={props.height} settingWidth={props.settingWidth} settingHeight={props.settingHeight}/>
                        <ImageUpload display={props.data.length == 2 ? 'block' : 'none' } num={2} settingImage={settingImage} width={props.width} height={props.height} settingWidth={props.settingWidth} settingHeight={props.settingHeight}/>
                        <ImageUpload display={props.data.length == 3 ? 'block' : 'none' } num={3} settingImage={settingImage} width={props.width} height={props.height} settingWidth={props.settingWidth} settingHeight={props.settingHeight}/>
                        <ImageUpload display={props.data.length == 4 ? 'block' : 'none' } num={4} settingImage={settingImage} width={props.width} height={props.height} settingWidth={props.settingWidth} settingHeight={props.settingHeight}/>
                        <ImageUpload display={props.data.length == 5 ? 'block' : 'none' } num={5} settingImage={settingImage} width={props.width} height={props.height} settingWidth={props.settingWidth} settingHeight={props.settingHeight}/>
                        <ImageUpload display={props.data.length == 6 ? 'block' : 'none' } num={6} settingImage={settingImage} width={props.width} height={props.height} settingWidth={props.settingWidth} settingHeight={props.settingHeight}/>
                        <ImageUpload display={props.data.length == 7 ? 'block' : 'none' } num={7} settingImage={settingImage} width={props.width} height={props.height} settingWidth={props.settingWidth} settingHeight={props.settingHeight}/>
                        <ImageUpload display={props.data.length == 8 ? 'block' : 'none' } num={8} settingImage={settingImage} width={props.width} height={props.height} settingWidth={props.settingWidth} settingHeight={props.settingHeight}/>
                        <ImageUpload display={props.data.length == 9 ? 'block' : 'none' } num={9} settingImage={settingImage} width={props.width} height={props.height} settingWidth={props.settingWidth} settingHeight={props.settingHeight}/>
                        <ImageUpload display={props.data.length == 10 ? 'block' : 'none' } num={10} settingImage={settingImage} width={props.width} height={props.height} settingWidth={props.settingWidth} settingHeight={props.settingHeight}/>
                        <ImageUpload display={props.data.length == 11 ? 'block' : 'none' } num={11} settingImage={settingImage} width={props.width} height={props.height} settingWidth={props.settingWidth} settingHeight={props.settingHeight}/>
                        <ImageUpload display={props.data.length == 12 ? 'block' : 'none' } num={12} settingImage={settingImage} width={props.width} height={props.height} settingWidth={props.settingWidth} settingHeight={props.settingHeight}/>
                        <ImageUpload display={props.data.length == 13 ? 'block' : 'none' } num={13} settingImage={settingImage} width={props.width} height={props.height} settingWidth={props.settingWidth} settingHeight={props.settingHeight}/>
                        <ImageUpload display={props.data.length == 14 ? 'block' : 'none' } num={14} settingImage={settingImage} width={props.width} height={props.height} settingWidth={props.settingWidth} settingHeight={props.settingHeight}/>
                        <ImageUpload display={props.data.length == 15 ? 'block' : 'none' } num={15} settingImage={settingImage} width={props.width} height={props.height} settingWidth={props.settingWidth} settingHeight={props.settingHeight}/>
                        <ImageUpload display={props.data.length == 16 ? 'block' : 'none' } num={16} settingImage={settingImage} width={props.width} height={props.height} settingWidth={props.settingWidth} settingHeight={props.settingHeight}/>
                        <ImageUpload display={props.data.length == 17 ? 'block' : 'none' } num={17} settingImage={settingImage} width={props.width} height={props.height} settingWidth={props.settingWidth} settingHeight={props.settingHeight}/>
                        <ImageUpload display={props.data.length == 18 ? 'block' : 'none' } num={18} settingImage={settingImage} width={props.width} height={props.height} settingWidth={props.settingWidth} settingHeight={props.settingHeight}/>
                        <ImageUpload display={props.data.length == 19 ? 'block' : 'none' } num={19} settingImage={settingImage} width={props.width} height={props.height} settingWidth={props.settingWidth} settingHeight={props.settingHeight}/>
                </Form.Group>
                </Form.Row>
            </Form>: ""}
            <Form.Row>
            <Form.Group controlId="formBasicPassword" as={Col} sm="12" md="12" lg="12">
                <div style={{borderTop: "1px solid #ced4da"}}>
                <Button variant="success" style={{marginTop:"16px"}} onClick={() => props.addData({label: label, value:value, color:color, image:image, width: props.width, height: props.height, pattern: props.pattern})}>
                    Add Data
                </Button>
                </div>
            </Form.Group>
            </Form.Row> 
        </Form>
        
            </Card.Body>
            </Accordion.Collapse>
        </Card>
        </Accordion>
       
    </Fragment>
  );
}

export default Inputs;
